import { IntegrationService } from './../../core/services/integration.service';
import { Component, Input, ViewChild, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { EnvironmentParameters } from '../models/environment-parameters';
import { UtilsService } from '../services/utils.service';
import { Subscription } from 'rxjs/Subscription';
import { CryptoDataService } from '../../core/services/crypto.data.service';
import { BzgModalService, BzgToastService } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { BzgToastType } from 'bz-genome-angular/toast/toast.config';
import { NgForm } from '@angular/forms';
import { BzgToastRef } from 'bz-genome-angular/toast/toast.ref';
import { SmsConfigurationComponent } from './sms-configuration/sms-configuration.component';
import { Router } from '@angular/router';
import { I18nService } from 'i18n/i18n.service';
import { IBasicOptions, IDefaultOptions, IOAuthOptions } from '../typings/IConfigurationEmail';
import { IConnectionTypeEmailIntegration } from '../typings/IConnectionTypeEmailIntegration';
import { DatePipe } from '@angular/common';
import { EnvironmentDataService } from '../services/environment.data.service';
import { ActionConfirmationComponent } from 'app/shared/components/action-confirmation/action-confirmation.component';
import { ConfirmationType } from 'app/core/models/confirmation-type.enum';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
  selector: 'environment-popular',
  templateUrl: 'environment-popular.component.html',
  styleUrls: ['environment-popular.component.scss']
})
export class EnvironmentPopularComponent implements OnChanges {

  @Input() parameters: EnvironmentParameters;
  @Input() metadata: any;
  @Input() sections: any;
  @Input() configurationEmail: any;
  @Input() SMTPSenderAcc: any;
  @Input() defaultSender: any;
  @Input() EnableWsSecurity: boolean = false;

  public emailIntegrationConnectionType: string;
  public emailIntegrationConnectionTypeList: Array<string>;
  public emailIntegrationPassword: string = null;
  public wsSecurityPassword: string;
  public validConfigEmail = true;
  public testResult: boolean;
  public submittedTestEmail: boolean;
  public testingEmail: boolean;
  public encryptingEmail: boolean;
  public currentConnection: IConnectionTypeEmailIntegration;
  public showAlertMessage = false;
  public hideCertificateMessage = false;
  public showEncryptFlagOAuth: boolean = false;
  public showEncryptFlagBasic: boolean = false;
  
  // Add flag to prevent concurrent encryption
  private _encryptingAnonymousSecret: boolean = false;

  private _passwordsInitialized = 0;
  private _emailConnectionTypes: Array<IConnectionTypeEmailIntegration>;
  public EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
  private _toastActionText = '';
  private _toastSubscription: Subscription;
  private __hideCertificateKey = 'hideSupportTicketMessage';
  public defaultOptions: IDefaultOptions;
  public basicOptions: IBasicOptions;
  public oAuthOptions: IOAuthOptions;
  public errorSender: string;
  public errorUri: string;
  public errorServer: string;
  public errorMail: string;

  public currentDate: Date = new Date();
  public colorDateCertificate: string;
  public expirationDate: Date;
  public textCertificate: string = '';
  public expirationDateFull = '';

  public enableButtonsCertificate: boolean = false;
  public showAlertSaveAgain: boolean = false;

  @ViewChild('environmentPopularForm', { static: true }) environmentPopularForm: NgForm;
  @ViewChild('smsComponent', { static: false }) smsComponent: SmsConfigurationComponent;

  constructor(
    public utilsService: UtilsService, private _router: Router,
    private _cryptoDataService: CryptoDataService, private _integrationService: IntegrationService,
    private _toastService: BzgToastService, private _translateService: TranslateService,
    private _i18nService: I18nService,
    private datePipe: DatePipe,
    private _environmentDataService: EnvironmentDataService,
    private _modalService: BzgModalService,
    private _showToastService: ShowToastService ) {

  }

  async ngOnInit() {
    this.hideCertificateMessage = localStorage.getItem(this.__hideCertificateKey) === 'true';
    this._emailConnectionTypes = await this._integrationService.getEmailConnectionTypes();
    this.emailIntegrationConnectionType = this.parameters
      .emailIntegrationConnectionType
      ? this.parameters.emailIntegrationConnectionType
      : 'None';
    if (this.EnableWsSecurity)
      this.getCertificate();
    this.updateCurrentEmailIntegrationConnectionTypeConfiguration();
    this._initializeLists();
    this._setDefaultValuePasswords();
    this.validateEmailIntegrationParameters();
  };

  ngOnChanges(changes: SimpleChanges): void {

    if (this.parameters)
      this.wsSecurityPassword = this.parameters.wsSecurityPassword;

    if (this.configurationEmail) {
      this.defaultOptions = this.configurationEmail.methods[0].options;
      this.basicOptions = this.configurationEmail.methods[1].options;
      this.oAuthOptions = this.configurationEmail.methods[2].options;
    }
  }

  public setEmailIntegrationConnectionType(value: string) {
    this.emailIntegrationConnectionType = value;
    this.showAlertMessage = false;
    this.updateCurrentEmailIntegrationConnectionTypeConfiguration();
    this.parameters.emailIntegrationConnectionType = value;
    this.validateEmailIntegrationParameters();
  };

  public updateCurrentEmailIntegrationConnectionTypeConfiguration() {
    this.currentConnection = this._emailConnectionTypes.find(
      connection =>
        connection.protocol === this.emailIntegrationConnectionType
    );
    if (!this.currentConnection.enabled) {
      this.showAlertMessage = true;
    }
  }

  public encryptEmailIntegrationPassword() {

    if (this._passwordsInitialized === 0) {
      this._setDefaultValuePasswords();
    }

    if (this.emailIntegrationPassword !== undefined && (this.emailIntegrationPassword.length > 0)) {
      this.encryptingEmail = true;
      this.submittedTestEmail = false;
      this._cryptoDataService.encryptString(this.emailIntegrationPassword)
        .map(response => response)
        .subscribe(result => {
          this.parameters.emailIntegrationPassword = result.encryptedPassword;
          this.encryptingEmail = false;
        });
    }
    else {
      this.parameters.emailIntegrationPassword = '';
    }
  };

  public async _encryptWSSecurityPassword() {
    if (this.wsSecurityPassword !== '****' && this.wsSecurityPassword && (this.wsSecurityPassword.length > 0)) {
      const passwordResult = await this._cryptoDataService.encryptString(this.wsSecurityPassword).toPromise();
      this.parameters.wsSecurityPassword = passwordResult.encryptedPassword;
      this.wsSecurityPassword = passwordResult.encryptedPassword;
    } else if (this.wsSecurityPassword.length === 0 && this.wsSecurityPassword !== '****')
      this.parameters.wsSecurityPassword = null;
  };

  public testConfigurationEmail() {
    this.submittedTestEmail = false;
    if (this.encryptingEmail) {
      return;
    }
    if (this.validateEmailIntegrationParameters()) {
      this.testingEmail = true;
      this._integrationService.testEmail(
        {
          SSL: this.parameters.emailIntegrationEnableSsl,
          Port: this.parameters.emailIntegrationPort,
          Host: this.parameters.emailIntegrationHost,
          Protocol: this.parameters.emailIntegrationConnectionType,
          Password: this.parameters.emailIntegrationPassword,
          UserName: this.parameters.emailIntegrationUsername
        }).map(response => response)
        .subscribe(result => {
          if (!result.Successful) {
            this._showToastService.showToast(this._i18nService.instant('ENVIRONMENT.CONNECTION_COULD_NOT_BE_ESTABLISHED'), 'error');
          }
          else {
            this._showToastService.showToast(this._i18nService.instant('ENVIRONMENT.CONNECTION_COULD_BE_ESTABLISHED'), 'success');
          }
          this.submittedTestEmail = true;
          this.testingEmail = false;
        }, error => {
          this._showToastService.showToast(this._i18nService.instant('ENVIRONMENT.CONNECTION_COULD_NOT_BE_ESTABLISHED'), 'error');
        });
    } else {
      this._showToastService.showToast(this._i18nService.instant('ENVIRONMENT.PLEASE_COMPLETE_ALL_FIELDS'), 'error');
    }
  }

  private _initializeLists() {
    this.emailIntegrationConnectionTypeList = this._emailConnectionTypes
      .filter(connection => connection.enabled)
      .map(connection => connection.protocol);
  };

  private _setDefaultValuePasswords() {
    this._passwordsInitialized = 1;
    if (this.parameters.emailIntegrationPassword === null || this.parameters.emailIntegrationPassword === '') {
      this.emailIntegrationPassword = '';
    }
    else {
      this.emailIntegrationPassword = 'XXXXXX';
    }
  };


  public async isFormValid(): Promise<boolean> {
    const regex = /^CRYPT.[1-9].BIZAGI:/g;
    if (this.parameters.wsSecurityPassword && this.parameters.wsSecurityPassword.length > 0 && !this.parameters.wsSecurityPassword.match(regex))
      await this._encryptWSSecurityPassword();
    
    // Wait for any ongoing encryption and then check if we need to encrypt
    if (this.parameters.appsAnonymousUserClientSecret && this.parameters.appsAnonymousUserClientSecret.length > 0 && 
      !this.parameters.appsAnonymousUserClientSecret.match(regex)) {
      
      // Wait for any pending encryption to complete
      while (this._encryptingAnonymousSecret) {
        await new Promise(resolve => setTimeout(resolve, 50));
      }
      
      // Check again if encryption is still needed (might have been encrypted by onblur)
      if (!this.parameters.appsAnonymousUserClientSecret.match(regex)) {
        await this.encryptAnonymousUserClientSecret();
      }
    }
    Object.keys(this.environmentPopularForm.controls).forEach(c => this.environmentPopularForm.controls[c].markAsDirty());
    return this.environmentPopularForm.valid && this.smsComponent.isFormValid();
  }

  public validateEmailIntegrationParameters() {
    const currentConnectionEnabled = this.currentConnection ? this.currentConnection.enabled : false;
    switch (this.emailIntegrationConnectionType) {
      case 'None':
        this.validConfigEmail = !currentConnectionEnabled;
        this.parameters.emailIntegrationPort = null;
        break;
      case 'Exchange':
        this.validConfigEmail = this.parameters.emailIntegrationHost !== ''
          && currentConnectionEnabled
          && this.parameters.emailIntegrationPassword !== ''
          && this.parameters.emailIntegrationUsername !== '';
        this.parameters.emailIntegrationPort = null;
        break;
      default:
        this.validConfigEmail = this.parameters.emailIntegrationPort >= 0
          && this.parameters.emailIntegrationHost !== ''
          && currentConnectionEnabled
          && this.parameters.emailIntegrationPassword !== ''
          && this.parameters.emailIntegrationUsername !== '';
        this.parameters.emailIntegrationPort = 0;
        break;
    }
    return this.validConfigEmail;
  }

  public isValidateControl(validation: string, enable: string) {
    if (this.parameters[enable]) {
      return this.metadata[validation] ? this.metadata[validation].required : false;
    }
  }

  public isValidSelect(name: string) {
    return (
      this.environmentPopularForm.controls[name] &&
      this.environmentPopularForm.controls[name].dirty &&
      this.environmentPopularForm.controls[name].invalid
    );
  }

  public navigateWindowMaintenance() {
    this._router.navigate(['mc', 'Maintenance']);
  }

  public onCloseCertificateMessage() {
    this.hideCertificateMessage = true;
    localStorage.setItem(this.__hideCertificateKey, this.hideCertificateMessage.toString());
  }

  public changeConfiguration(valueConfiguration) {
    this.configurationEmail.active = valueConfiguration;
  }

  public validateConfigurationEmail() {
    return this.configurationEmail && this.defaultOptions && this.oAuthOptions && this.basicOptions;
  }

  encryptBasicSecurityPassword(field) {
    let property = null;
    if (field === 0)
      property = this.oAuthOptions.clientSecret;
    else
      property = this.basicOptions.smtpPassword;

    this.encryptService(property, field);
  }

  encryptService(property, field) {
    if (property && (property.length > 0) && property !== '****') {
      this._cryptoDataService.encryptString(property).subscribe(result => {
        if (field === 0)
          this.oAuthOptions.clientSecret = result.encryptedPassword;
        else
          this.basicOptions.smtpPassword = result.encryptedPassword;
      });
    }
  }

  public async encryptAnonymousUserClientSecret() {
    // Prevent concurrent encryption calls
    if (this._encryptingAnonymousSecret) {
      return;
    }

    if (this.parameters.appsAnonymousUserClientSecret !== '****' && this.parameters.appsAnonymousUserClientSecret && 
      (this.parameters.appsAnonymousUserClientSecret.length > 0)) {
      
      this._encryptingAnonymousSecret = true;
      
      try {
        const passwordResult = await this._cryptoDataService.encryptString(this.parameters.appsAnonymousUserClientSecret).toPromise();
        this.parameters.appsAnonymousUserClientSecret = passwordResult.encryptedPassword;
      } catch (error) {
        console.error('Error encrypting anonymous user client secret:', error);
      } finally {
        this._encryptingAnonymousSecret = false;
      }
    } else if (this.parameters.appsAnonymousUserClientSecret && this.parameters.appsAnonymousUserClientSecret.length === 0 && this.parameters.appsAnonymousUserClientSecret !== '****') {
      this.parameters.appsAnonymousUserClientSecret = null;
    }
  };

  showErrorGuid(guid) {
    let showError = true;
    if (guid) {
      if (guid.length === 36) {
        const regex = /\b[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\b/g;
        const guidValid = guid.match(regex);
        if (guidValid)
          showError = false;
      }
    }
    if (guid === '00000000-0000-0000-0000-000000000000')
      showError = true;
    if (guid.length === 0)
      showError = false;
    return showError;
  }

  validateGeneric(event, value) {
    let regex = null;
    const pressKey = event.key;

    if (value === 0)
      regex = /[0-9]/;
    else if (value === 1)
      regex = /[^\s]/;
    else
      regex = /[a-zA-Z0-9-.:/,]/;

    const allowKey = pressKey.match(regex);
    if (!allowKey) {
      event.preventDefault();
    }
  }

  validateGenericBlur(value) {
    let field = '';
    let regex = null;

    if (value === 0) {
      this.errorSender = this._i18nService.instant('ENVIRONMENT.EMAIL_CONFIGURATION_SPECIAL');
      field = this.defaultOptions.prefixSender;
      regex = /^[a-zA-Z0-9-_.#]+$/;
    } else {
      this.errorUri = this._i18nService.instant('ENVIRONMENT.EMAIL_OAUTH_URL');
      field = this.oAuthOptions.accessTokenURI;
      regex = /^\S+$/;
    }

    let error = false;

    if (field) {
      const resultado = regex.test(field);
      if (!resultado)
        error = true;
    }

    return error;
  }

  validateServerBlur(value) {
    let field = '';
    let error = false;

    if (value === 0)
      field = this.oAuthOptions.smtpServer;
    else
      field = this.basicOptions.smtpServer;

    if (field) {
      const resultado = /^[a-zA-Z0-9-.:/,]+$/.test(field);
      if (!resultado) {
        this.errorServer = this._i18nService.instant('ENVIRONMENT.EMAIL_OAUTH_SMTSERVER_INVALID');
        error = true;
      }
    }

    return error;
  }

  validateMail(value) {
    let error = false;
    let field = '';

    if (value === 0)
      field = this.basicOptions.sendEmailBCCTo;
    else if (value === 1)
      field = this.basicOptions.sendEmailCCTo;
    else if (value === 2)
      field = this.oAuthOptions.sendEmailBCCTo;
    else if (value === 3)
      field = this.oAuthOptions.sendEmailCCTo;
    else if (value === 4)
      field = this.defaultOptions.sendEmailBCCTo;
    else
      field = this.defaultOptions.sendEmailCCTo;

    if (field) {
      const resultado = /^([\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,})(\s*;\s*[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,})*$/.test(field);
      if (!resultado) {
        this.errorMail = this._i18nService.instant('ENVIRONMENT.EMAIL_MAIL_ERROR');
        error = true;
      }
    }
    return error;
  }

  validateUniqueMail() {
    let error = false;
    let field = this.basicOptions.smtpSenderAcc;
    if (field) {
      const resultado = /^\S+@\S+\.\S+$/.test(field);
      if (!resultado) {
        this.errorMail = this._i18nService.instant('ENVIRONMENT.EMAIL_MAIL_ERROR');
        error = true;
      }
    }
    return error;
  }

  validateSender(event) {
    const pressKey = event.key;
    const allowKey = pressKey.match(/[a-zA-Z0-9-_.#]/);
    let doubleSpecial = false;

    if (this.defaultOptions.prefixSender) {
      const lastCharacter = this.defaultOptions.prefixSender[this.defaultOptions.prefixSender.length - 1];
      const allowLast = lastCharacter.match(/[-_.#]/);
      const actualCharacter = pressKey.match(/[-_.#]/);
      doubleSpecial = allowLast && actualCharacter;
    }

    if (!allowKey || doubleSpecial) {
      event.preventDefault();
    }
  }

  invalidSender() {
    let error = false;
    if (this.defaultOptions.prefixSender) {
      const firstCharacter = this.defaultOptions.prefixSender[0];
      const lastCharacter = this.defaultOptions.prefixSender[this.defaultOptions.prefixSender.length - 1];
      const allowFirst = firstCharacter.match(/[-_.#]/);
      const allowLast = lastCharacter.match(/[-_.#]/);
      if (allowFirst) {
        this.errorSender = this._i18nService.instant('ENVIRONMENT.EMAIL_CONFIGURATION_START');
        error = true;
      }
      if (allowLast) {
        this.errorSender = this._i18nService.instant('ENVIRONMENT.EMAIL_CONFIGURATION_END');
        error = true;
      }

      const doubleCharacter = this.defaultOptions.prefixSender.match(/^(?!.*[-_.#]{2})[a-zA-Z0-9-_.#]+$/);
      if (!doubleCharacter) {
        this.errorSender = this._i18nService.instant('ENVIRONMENT.EMAIL_MAIL_ERROR_CHARACTERS');;
        error = true;
      }
    }
    return error;
  }

  validateMaxNumber(field) {
    if (field === 0 && parseInt(this.oAuthOptions.smtpPort.toString()) > 49000) {
      this.oAuthOptions.smtpPort = 49000;
    }
    if (field === 0 && this.oAuthOptions.smtpPort.toString() === '') {
      this.oAuthOptions.smtpPort = 0;
    }
    if (field === 0 && this.oAuthOptions.smtpPort.toString() !== ''
      && this.oAuthOptions.smtpPort.toString().length > 0 &&
      !parseInt(this.oAuthOptions.smtpPort.toString())) {
      this.oAuthOptions.smtpPort = 0;
    }
    if (field === 1 && parseInt(this.basicOptions.smtpPort.toString()) > 49000) {
      this.basicOptions.smtpPort = 49000;
    }
    if (field === 1 && this.basicOptions.smtpPort.toString() === '') {
      this.basicOptions.smtpPort = 0;
    }
    if (field === 1 && this.basicOptions.smtpPort.toString() !== ''
      && this.basicOptions.smtpPort.toString().length > 0 &&
      !parseInt(this.basicOptions.smtpPort.toString())) {
      this.basicOptions.smtpPort = 0;
    }
  }

  showEncrypt(value) {
    if (value === 0)
      this.showEncryptFlagOAuth = !this.showEncryptFlagOAuth;
    else
      this.showEncryptFlagBasic = !this.showEncryptFlagBasic;
  }

  maxLengthPassword(value) {
    let field = '';
    if (value === 0)
      field = this.oAuthOptions.clientSecret;
    else
      field = this.basicOptions.smtpPassword;
    return field.startsWith('CRYPT.4.BIZAGI:') ? 500 : 256;
  }

  compareDates(): void {
    if (this.expirationDate && this.currentDate) {
      const expirationDate = new Date(this.expirationDate);
      expirationDate.setHours(0, 0, 0, 0);

      const currentDateStartOfDay = new Date(this.currentDate);
      currentDateStartOfDay.setHours(0, 0, 0, 0);
      if (expirationDate.getTime() < currentDateStartOfDay.getTime()) {
        this.textCertificate = this._i18nService.instant('ENVIRONMENT.CERTIFICATE_EXPIRED');
        this.colorDateCertificate = 'bz-environment-popular__certificate-date-message-expired';
      }
      else {
        const oneDay = 24 * 60 * 60 * 1000;
        const differenceInDays = Math.round(Math.abs((this.currentDate.getTime() - expirationDate.getTime()) / oneDay));
        if (differenceInDays > 58) {
          this.textCertificate = this._i18nService.instant('ENVIRONMENT.CERTIFICATE_ACTIVE');
          this.colorDateCertificate = 'bz-environment-popular__certificate-date-message-active';
        }
        else {
          this.textCertificate = this._i18nService.instant('ENVIRONMENT.CERTIFICATE_SOON');
          this.colorDateCertificate = 'bz-environment-popular__certificate-date-message-warning';
        }
      }
    }
  }

  downloadCertificate() {
    const nameCertificate = 'Certificate.zip';
    this._environmentDataService.downloadCertificate(nameCertificate).subscribe(res => {
      this._showToastService.showToast(this._i18nService.instant('ENVIRONMENT.DOWNLOAD_CERTIFICATE_SUCCESS'), 'success');
    });
  }

  getCertificate() {
    this._environmentDataService.getCertificate().subscribe(result => {
      if (result) {
        this.expirationDate = result.ExpirationDate;
        this.enableButtonsCertificate = true;
        this.compareDates();
        this.compareWsSecurityX509CertFindValue(result.FindValue);
      }
    });
  }

  compareWsSecurityX509CertFindValue(wsSecurityX509CertFindValue) {
    // TODO: Compare the truth of the services to see if this applies.
    const defaultValueDate = new Date(this.parameters.wsSecurityX509CertFindValue);
    const defaultValueDay = defaultValueDate.getDate();
    const defaultValueMonth = defaultValueDate.getMonth();
    const defaultValueYear = defaultValueDate.getFullYear();

    const newValueDate = new Date(wsSecurityX509CertFindValue);
    const newValueDay = newValueDate.getDate();
    const newValueMonth = newValueDate.getMonth();
    const newValueYear = newValueDate.getFullYear();


    if (this.parameters.wsSecurityX509CertFindValue === wsSecurityX509CertFindValue || (defaultValueDay === newValueDay &&
      defaultValueMonth === newValueMonth &&
      defaultValueYear === newValueYear)) {
      this.showAlertSaveAgain = false;
    }
    else {
      this.showAlertSaveAgain = true;
      this.parameters.wsSecurityX509CertFindValue = wsSecurityX509CertFindValue;
    }

  }

  updatetCertificateConfirmation() {
    const title = this._i18nService.instant("ENVIRONMENT.UPDATE_CERTIFICATE");
    const message = this._i18nService.instant("ENVIRONMENT.UPDATE_CERTIFICATE_INFO");
    const button = this._i18nService.instant("GLOBAL.UPDATE");
    const modal = this._modalService.open(ActionConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: { title, message, type: ConfirmationType.CONFIRMATION, button, disabledColorButton: true }
    });
    modal.afterClosed().subscribe((result) => {
      if (result === ConfirmationType.CONFIRMATION)
        this.updatetCertificate();
    });
  }

  updatetCertificate() {
    this._environmentDataService.updateCertificate().subscribe(result => {
      if (result) {
        this.expirationDate = result.ExpirationDate;
        this.enableButtonsCertificate = true;
        this.compareDates();
        this.compareWsSecurityX509CertFindValue(result.FindValue);
        this._showToastService.showToast(this._i18nService.instant('ENVIRONMENT.UPDATE_CERTIFICATE_SUCCESS'), 'success');
      }
    });
  }

  onClick() {
    this.parameters.wsSecurityEnabled = !this.parameters.wsSecurityEnabled
  }
}
